import {
  Button,
  Card,
  Col,
  Form,
  Icon,
  Input,
  notification,
  Row,
  Select,
  Tag
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { hideLoader, showLoader } from '../../../modules/actions'
import Request from '../../../request'
import { getUrlParams } from '../../../routes'
import { apiUrl as apiurl } from '../../../settings'

import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import {
  formItemLayout,
  getSlugUrl,
  InputBox
} from '../../../components/_utils/appUtils'
import { GetJournal, UpdateJournal } from '../actions'

const { Option } = Select

@Form.create()
class SpecialIssue extends PureComponent {
  state = {
    edit: true,
    fileKey: moment(),
    specialIssueJournalFile: {},
    specialIssueThumbFile: {},
    oldJournalFile: {},
    oldThumbFile: {},
    chiefEditorList: [],
    journalName: ''
  }

  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let { id: _id, specialIssueJournalFile, specialIssueThumbFile } = this.state
        let fd = new FormData()
        
        // Structure the data to match the expected backend nested object
        const formattedData = {
          _id,
          specialIssue: {
            name: valData['specialIssue.name'],
            journalShortName: valData['specialIssue.journalShortName'],
            tagLine: valData['specialIssue.tagLine'],
            slugJournal: valData['specialIssue.slugJournal'],
            printIssn: valData['specialIssue.printIssn'],
            onlineIssn: valData['specialIssue.onlineIssn'],
            chiefEditorId: valData['specialIssue.chiefEditorId'],
            publication: valData['specialIssue.publication'],
            ranking: valData['specialIssue.ranking'],
            rating: valData['specialIssue.rating'],
            factor: valData['specialIssue.factor'],
            frequency: valData['specialIssue.frequency'],
            type: valData['specialIssue.type'],
            subjects: valData['specialIssue.subjects'],
            indexingServices: valData['specialIssue.indexingServices'],
            shortDescription: valData['specialIssue.shortDescription'],
            description: valData['specialIssue.description'],
            aimAndScope: valData['specialIssue.aimAndScope'],
            openAccess: valData['specialIssue.openAccess'],
            copyright: valData['specialIssue.copyright'],
            disclaimer: valData['specialIssue.disclaimer'],
            articleCopyright: valData['specialIssue.articleCopyright'],
          }
        }

        fd.append('obj', JSON.stringify(formattedData))

        if (specialIssueJournalFile && specialIssueJournalFile.name) {
          fd.append('specialIssueJournalFile', specialIssueJournalFile)
        }
        if (specialIssueThumbFile && specialIssueThumbFile.name) {
          fd.append('specialIssueThumbFile', specialIssueThumbFile)
        }

        let x = await dispatch(UpdateJournal(fd))

        let { error, message } = x

        if (!error) {
          notification.success({
            message: "Special Issue updated successfully"
          })
        } else {
          notification.error({
            message: message,
            description: message
          })
        }
      }
    })
  }

  setFormValues = async id => {
    const { dispatch, form } = this.props
    dispatch(showLoader())
    let { error, data } = await dispatch(GetJournal({ id }))
    if (error) {
      notification.error({
        message: 'Error Loading Data'
      })
    } else {
      setTimeout(() => {
        const si = data.specialIssue || {}
        this.setState({ journalName: data.name })
        
        form.setFieldsValue({
          'specialIssue.name': si.name,
          'specialIssue.journalShortName': si.journalShortName,
          'specialIssue.tagLine': si.tagLine,
          'specialIssue.slugJournal': si.slugJournal,
          'specialIssue.printIssn': si.printIssn,
          'specialIssue.onlineIssn': si.onlineIssn,
          'specialIssue.chiefEditorId': si.chiefEditorId,
          'specialIssue.publication': si.publication,
          'specialIssue.ranking': si.ranking,
          'specialIssue.rating': si.rating,
          'specialIssue.factor': si.factor,
          'specialIssue.frequency': si.frequency,
          'specialIssue.type': si.type,
          'specialIssue.subjects': si.subjects,
          'specialIssue.indexingServices': si.indexingServices,
          'specialIssue.shortDescription': si.shortDescription,
          'specialIssue.description': si.description,
          'specialIssue.aimAndScope': si.aimAndScope,
          'specialIssue.openAccess': si.openAccess,
          'specialIssue.copyright': si.copyright,
          'specialIssue.disclaimer': si.disclaimer,
          'specialIssue.articleCopyright': si.articleCopyright,
        })

        this.getChiefEditorId(data.name)
        
        if (data.specialIssueJournalFile && data.specialIssueJournalFile.path) {
          this.setState({ oldJournalFile: data.specialIssueJournalFile })
        }
        if (data.specialIssueThumbFile && data.specialIssueThumbFile.path) {
          this.setState({ oldThumbFile: data.specialIssueThumbFile })
        }
      }, 500)
    }
    dispatch(hideLoader())
  }

  handleChange = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }

  getChiefEditorId = async journalName => {
    let { data } = await Request.getChiefEditor({
      journalName
    })
    this.setState({ chiefEditorList: data })
  }

  componentDidMount() {
    let data = getUrlParams('journals.special-issue', this.props.pathname)
    if (!!data) {
      let { id } = data
      this.setState({
        id: id
      })
      this.setFormValues(id)
    }
  }

  render() {
    const { chiefEditorList, oldJournalFile, oldThumbFile, journalName } = this.state
    const {
      form: { getFieldDecorator, setFieldsValue, loading }
    } = this.props

    const inputSchma = {
      fields: [
        {
          label: 'Special Issue Name ',
          key: 'specialIssue.name',
          required: true,
          placeholder: 'Special Issue Name',
          onChange: ({ target }) => {
            let { value } = target
            setFieldsValue({
              'specialIssue.name': value,
              'specialIssue.slugJournal': getSlugUrl(value)
            })
          }
        },
        {
          label: 'Special Issue Short Name ',
          key: 'specialIssue.journalShortName',
          required: true,
          placeholder: 'Short Name'
        },
        {
          label: 'Tag Line',
          key: 'specialIssue.tagLine',
          placeholder: 'Tag Line',
          span: 24
        },
        {
          label: 'Slug Journal ',
          key: 'specialIssue.slugJournal',
          required: true,
          placeholder: 'Slug'
        },
        { label: 'Print Issn', key: 'specialIssue.printIssn', placeholder: 'Print Issn' },
        { label: 'Online Issn', key: 'specialIssue.onlineIssn', placeholder: 'Online Issn' },
        {
          label: 'Chief Editor',
          key: 'specialIssue.chiefEditorId',
          required: true,
          placeholder: 'Select Editor',
          options: chiefEditorList,
          keyAccessor: x => x._id,
          valueAccessor: x => x.name,
          type: 'select',
          showSearch: true
        },
        {
          label: 'Journal File ',
          key: 'specialIssueJournalFile',
          type: 'file',
          customField: (
            <InputBox title={`Journal File`} className={'rowFlex'}>
              <Input
                type={'file'}
                name={'specialIssueJournalFile'}
                id={'specialIssueJournalFile'}
                className={'form-control'}
                key={this.state.fileKey}
                onChange={e => {
                  this.handleChange(e)
                }}
              />
              {oldJournalFile && oldJournalFile.path ? (
                <a
                  className={'linkBtn'}
                  target={'_blank'}
                  href={oldJournalFile.path}>
                  <Icon type={'eye'} />
                </a>
              ) : null}
            </InputBox>
          )
        },
        {
          label: 'Thumb Journal Image',
          key: 'specialIssueThumbFile',
          type: 'file',
          customField: (
            <InputBox title={`Thumb Image`} className={'rowFlex'}>
              <Input
                type={'file'}
                name={'specialIssueThumbFile'}
                id={'specialIssueThumbFile'}
                className={'form-control'}
                key={'thumb-file-key'}
                onChange={e => {
                  this.handleChange(e)
                }}
              />
              {oldThumbFile && oldThumbFile.path ? (
                <a
                  className={'linkBtn'}
                  target={'_blank'}
                  href={oldThumbFile.path}>
                  <Icon type={'eye'} />
                </a>
              ) : null}
            </InputBox>
          )
        },
        {
          label: 'Month(s) of publication',
          key: 'specialIssue.publication',
          placeholder: 'Month(s) of publication'
        },
        {
          label: 'Scientifical Journal Ranking (scopus)',
          key: 'specialIssue.ranking',
          placeholder: 'Ranking'
        },
        {
          label: 'National Academy of Agricultural Services (NAAS)',
          key: 'specialIssue.rating',
          placeholder: 'NAAS Rating'
        },
        {
          label: 'Impact Factor (ISI Thomson Reuters)',
          key: 'specialIssue.factor',
          placeholder: 'Impact Factor'
        },
        {
          label: 'Frequency',
          key: 'specialIssue.frequency',
          placeholder: 'Frequency'
        },
        { label: 'Type', key: 'specialIssue.type', placeholder: 'Type' },
        {
          label: 'Related Subjects',
          key: 'specialIssue.subjects',
          type: 'textArea',
          placeholder: 'Related Subjects',
          span: 24
        },
        {
          label: 'Indexing services',
          key: 'specialIssue.indexingServices',
          type: 'textArea',
          placeholder: 'Indexing services',
          span: 24
        },
        {
          label: 'Short Description',
          key: 'specialIssue.shortDescription',
          placeholder: 'Short Description',
          type: 'textArea',
          rows: 6,
          span: 24
        },
        {
          label: 'Description',
          key: 'specialIssue.description',
          placeholder: 'Description',
          type: 'ckeditor4',
          rows: 8,
          height: 100,
          span: 24
        },
        {
          label: 'Aim and Scope',
          key: 'specialIssue.aimAndScope',
          placeholder: 'Aim and Scope',
          type: 'ckeditor4',
          rows: 8,
          height: 100,
          span: 24
        },
        {
          label: 'Open Access',
          key: 'specialIssue.openAccess',
          placeholder: 'Open Access',
          type: 'ckeditor4',
          rows: 8,
          height: 100,
          span: 24
        },
        {
          label: 'Copyright',
          key: 'specialIssue.copyright',
          placeholder: 'Copyright',
          type: 'ckeditor4',
          rows: 6,
          height: 50,
          span: 24
        },
        {
          label: 'Disclaimer',
          key: 'specialIssue.disclaimer',
          placeholder: 'Disclaimer',
          type: 'ckeditor4',
          rows: 6,
          height: 50,
          span: 24
        },
        {
          label: 'Article Copyright',
          key: 'specialIssue.articleCopyright',
          placeholder: 'Article Copyright',
          type: 'ckeditor4',
          rows: 6,
          height: 50,
          span: 24
        }
      ]
    }

    return (
      <PageHeaderWrapper title={journalName ? `Edit Special Issue - ${journalName}` : 'Edit Special Issue'}>
        <Card bordered={true}>
          <Form
            onSubmit={this.handleSubmit}
            hideRequiredMark
            className={'inputForm'}>
            <Row gutter={16}>
              {inputSchma.fields.map((item, key) => {
                return (
                  <Col
                    span={item.span ? item.span : 12}
                    md={item.span ? item.span : 12}
                    sm={12}
                    xs={24}
                    key={key}>
                    {item.customField ? (
                      item.customField
                    ) : (
                      <GetEachFormFields
                        item={item}
                        getFieldDecorator={getFieldDecorator}
                        formItemLayout={formItemLayout}
                      />
                    )}
                  </Col>
                )
              })}
            </Row>

            <Form.Item style={{ marginTop: 32 }}>
              <Button
                type='primary'
                htmlType='submit'
                loading={this.props.loading}>
                UPDATE SPECIAL ISSUE
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  pathname: router.location.pathname
})

export default connect(mapStateToProps)(SpecialIssue)
